import { UserRoleSchema } from "@redotech/account-common/user-role";
import * as z from "zod";

export const getUserRolesOnTeam = {
  name: "getUserRolesOnTeam" as const,
  input: z.null(),
  output: z.object({ userRoles: z.array(UserRoleSchema) }),
};
